import BookNow from './container';

export default BookNow;



// WEBPACK FOOTER //
// ./app/src/components/EventHeader/BookNow/index.jsx